// @flow
import React from 'react';

import type { Experiment, Variant } from './duck';

function _initializeEmptyExperiment(experimentLabel: string): Experiment {
  return {
    experimentId: '',
    experimentLabel,
    variants: [
      {
        index: 0,
        testLabel: 'Original',
        component: null,
      },
      {
        index: 1,
        testLabel: 'Variant',
        component: null,
      },
    ],
  };
}

const experiments: { [key: string]: Experiment } = {
  // mostEffectiveQuoteStepBenefitsBlock: _initializeEmptyExperiment('mostEffectiveQuoteStepBenefitsBlock'),
  mostEffectiveCheckoutStep: _initializeEmptyExperiment('mostEffectiveCheckoutStep'),
};

if (process.env.WEBAPP_ENV === 'local') {
} else if (process.env.WEBAPP_ENV === 'development' || process.env.WEBAPP_ENV === 'staging') {
  // experiments.mostEffectiveQuoteStepBenefitsBlock.experimentId = 'tKKdBewvR-KQGaFQw7OXxg';
  experiments.mostEffectiveCheckoutStep.experimentId = 'DdxN2uYiTQSwPF51-hcGHQ';
} else if (process.env.WEBAPP_ENV === 'production') {
  // experiments.mostEffectiveQuoteStepBenefitsBlock.experimentId = 'hsLAPwR6QFigKUtNfUNfqw';
  experiments.mostEffectiveCheckoutStep.experimentId = 'NdbB3uhDRYKgCYK1BwnNMg';
}

export { experiments };



// WEBPACK FOOTER //
// ./src/modules/ab-test/experiments.js